import { useEffect, useState, useContext } from "react";
import axios from "axios";
import { Trophy, CheckCircle, Clock, XCircle, Award as AwardIcon } from "lucide-react";
import Header from "../component/header";
import Footer from "../component/Footer";
import Banner from "../component/Banner";
import BannerImg from "../image/gallaryBanner.png";
import { UserDataContext } from "../context/User";

const STATUS_CONFIG = {
  active:  { label: "Active",  Icon: CheckCircle, color: "bg-green-100 text-green-700"  },
  pending: { label: "Pending", Icon: Clock,        color: "bg-amber-100 text-amber-700"  },
  revoked: { label: "Revoked", Icon: XCircle,      color: "bg-red-100 text-red-700"      },
};

const Awards = () => {
  const { userData } = useContext(UserDataContext);
  const [awards, setAwards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAwards = async () => {
      try {
        // Fetch grant awards for the current user from the API
        const res = await axios.get("/api/auth/me", { withCredentials: true });
        setAwards([]);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchAwards();
  }, []);

  return (
    <div>
      <Header />
      <Banner backgroundImage={BannerImg} heading="My Awards" minHeight="40vh" padding="80px 0" />

      <section className="main-lwbl bg-[#F9FAFB] py-16 px-4 rounded-[30px]">
        <div className="max-w-4xl mx-auto">

          <div className="text-center mb-10">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center mx-auto mb-4 shadow-md">
              <Trophy size={28} className="text-white" strokeWidth={1.5} />
            </div>
            <h2 className="font-cinzel text-3xl font-bold text-gray-900 mb-2">Awards & Recognition</h2>
            <p className="font-outfit text-gray-500">Your achievements and grants awarded by the LWBL community.</p>
          </div>

          {loading ? (
            <div className="flex justify-center py-20">
              <div className="w-8 h-8 border-4 border-cyan-400 border-t-transparent rounded-full animate-spin" />
            </div>
          ) : awards.length === 0 ? (
            <div className="text-center py-20 bg-white rounded-3xl border border-gray-100 shadow-sm">
              <div className="w-16 h-16 rounded-2xl bg-gray-100 flex items-center justify-center mx-auto mb-4">
                <Trophy size={30} className="text-gray-300" strokeWidth={1.5} />
              </div>
              <h3 className="font-cinzel text-xl font-bold text-gray-700 mb-2">No Awards Yet</h3>
              <p className="font-outfit text-gray-400 text-sm max-w-sm mx-auto">
                Participate in quests, challenges, and community activities to earn awards and recognition.
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
              {awards.map((award) => {
                const sc = STATUS_CONFIG[award.status] || STATUS_CONFIG.pending;
                const StatusIcon = sc.Icon;
                return (
                  <div key={award._id}
                    className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 text-center hover:shadow-md transition-shadow">
                    <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center mx-auto mb-4 shadow">
                      <AwardIcon size={26} className="text-white" strokeWidth={1.5} />
                    </div>
                    <h4 className="font-cinzel font-bold text-gray-900 mb-1">{award.award?.title}</h4>
                    <p className="font-outfit text-sm text-gray-500 mb-3">{award.notes}</p>
                    <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold font-outfit ${sc.color}`}>
                      <StatusIcon size={11} strokeWidth={2.5} />
                      {sc.label}
                    </span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Awards;
